/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-02-25 10:21:52
 **/

export default class Queue<T = unknown> {
	#queue: T[] = [];

	constructor() {
		this.#queue = [];
	}

	public push(item: T) {
		this.#queue.push(item);
	}
	public pop() {
		return this.#queue.shift();
	}
	public get size() {
		return this.#queue.length;
	}
	public get empty() {
		return this.size <= 0;
	}
	public get queue() {
		return this.#queue;
	}
	public clear() {
		this.#queue = [];
	}
}
